import { render, staticRenderFns } from "./pi-activity.vue?vue&type=template&id=9703a52c&"
import script from "./pi-activity.vue?vue&type=script&lang=js&"
export * from "./pi-activity.vue?vue&type=script&lang=js&"
import style0 from "./pi-activity.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports